package antd.badge

import antd.card.CardComponent
import antd.card.CardGridProps
import kotlinext.js.jsObject
import react.ComponentType
import react.RBuilder
import react.RHandler

fun RBuilder.badge(handler: RHandler<BadgeProps>) = child(BadgeComponent::class, handler)
fun RBuilder.ribbon(handler: RHandler<BadgeRibbonComponentProps>) = child(BadgeComponent.Ribbon as ComponentType<BadgeRibbonComponentProps>, jsObject{}, handler)
